const ChatBot=()=>{
    return(
        <div>
    <iframe
src="https://www.chatbase.co/chatbot-iframe/keMuJmQZahovbSWTmIAgA"
width="100%"
style={{height:'520px',cursor:'pointer',border:'3px solid green',width:'100%'}}
frameborder="0"
></iframe>

    </div>
    );
}

export default ChatBot;